module.exports = __webpack_public_path__ + "15014edffda1c90d7822c4c473d24378.jpg";